export default __webpack_public_path__ + "static/media/img4.90150d8a.svg";